import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../services/auth/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  environment = environment;

  innerWidth = 0;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  @Output() showSideMenu = new EventEmitter<boolean>();

  // isMobile$ = this.utilService.isMobile$;
  role$ = this.authService.roles$;
  roleLiteral$ = this.authService.roleLiterals$;
  // username$ = this.store$.select(AuthSelect.username);

  token$ = this.authService.token$;

  isStageEnvironment =
    window.location.href.toLocaleLowerCase().indexOf('stage') !== -1 ||
    window.location.href.indexOf('local') !== -1
      ? true
      : false;
  userMenuItems: MenuItem[] = [];

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.userMenuItems = [
      {
        label: 'Έξοδος',
        icon: 'pi pi-logout',
        command: () => {
          this.authService.logout();
        },
      },
    ];
  }

  onUserButtonClick() {
    //this.router.navigate(['doctor/profile']);
  }

  getNameAndRole(): string {
    const data = this.token$.getValue();
    const name = data?.name ?? 'Unknown';
    const role = this.getRoleLiterals(data?.role ?? '');

    return `${name} - ${role}`;
  }

  getRoleLiterals(roles: string) {
    const roleArray = roles?.split(',');

    if (!roleArray || roleArray?.length === 0) return 'Ν/Α';

    switch (roleArray[0]) {
      case 'Admin':
        return 'Διαχειριστής κεντρικού συστήματος';
      case 'HospitalAdmin':
      case 'PrivateHospitalAdmin':
        return 'Διαχειριστής Νοσοκομείου';
      case 'EkapyAdmin':
        return 'Διαχειριστής ΕΚΑΠΥ';
      case 'Citizen':
        return 'Πολίτης';
      case 'ClinicAdmin':
      case 'PrivateClinicAdmin':
        return 'Διαχειριστής Κλινικής';
      case 'ViewOnly':
        return 'Χρήστης Προβολή';
      default:
        return 'Ν/Α';
    }
  }

  onLogoClick() {
    this.router.navigate(['/home']);
  }
}
